import React from "react";
import GetButtons from "./getButtons";
import { ExportToCsv } from "export-to-csv";
import formatedDate from "../../utilities/formatedDate";
import { getActiveCompany, getAllDealers } from "../../api";
import { toast } from "react-toastify";

const GetExport = (props) => {
  const {columns, exportedData, name , type} = props;

  const timestamp = new Date().toISOString().replace(/:/g, "-");
  const filename = `${name}_${timestamp}.csv`;

  const csvOptions = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    headers: columns.map((c) => c.header),
    filename: filename,
  };

  const handleExportData = async () => {
    if(exportedData.length === 0) {
      toast.error("No data found to export!")
    }else{
      if(type== "company"){
        const response = await  getActiveCompany()
        const companyData = response.data.result
        const exportedData = companyData?.map((item) => ({
          Name: item?.client_company_name,
          Code: item?.client_company_code,
          Manufacturer: item?.manufacturer,
          City: item?.city,
          Status: item?.is_active ? "Active" : "Deactivate",
          Created_on: formatedDate(item?.create_at),
        }));
  
        csvOptions.headers = Object.keys(exportedData[0]);
        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(exportedData);
       
      } else if(type== "dealer"){
        const response = await  getAllDealers()
        const dealerData = response.data.result
        const exportedData = dealerData.map((item) => ({
          Name: item.dealer_name,
          DealerCode: item.dealer_code,
          Company: item.company_id,
          Email: item.email,
          Mobile: item.phone_number,
          City: item.city,
          Navision: item.engage_sync_navision,
          Created_on: formatedDate(item.created_at),
          Status: item.is_active ? 'Active' : 'Deactivate',
        }));
  
        csvOptions.headers = Object.keys(exportedData[0]);
        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(exportedData);
       
  
      }else{
  
        csvOptions.headers = Object.keys(exportedData[0]);
        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(exportedData);
      }
    }



   

  };

  return (
    <>
      <GetButtons onClick={handleExportData} type="export" />
    </>
  );
};

export default GetExport;
